// extracted by mini-css-extract-plugin
export default {"container":"container__OZDp_","tab":"tab__rT1WJ"};